const state = {
    // 是否折叠菜单
    isCollapse: false
};

const getters = {};

const actions = {
};

const mutations = {
    // 切换菜单折叠状态
    toggleisCollapse(state) {
        state.isCollapse = !state.isCollapse;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
